import React from 'react';
import Graphs from '../../utils/graphutil.js';
import Containers from '../../utils/containerutil.js';

class BigPieChart extends React.Component {
	constructor(props) {
		super(props);

		window._fiSponsor.loadSessionInfo();
	}

	getNum(numStr) {
		var num = '';
		for(var w = 0; w !== numStr.length; w++) {
			if(!isNaN(parseInt(numStr[w]))) {
				num += numStr[w];
			}
			else {
				break;
			}
		}

		return parseInt(num);
	}

	render() {
		const fiPieSize = {
			width: (this.props.size) ? this.props.size.width : '60%',
			height: (this.props.size) ? this.props.size.height : 'auto'
		};
		
		const tooltipString = (window._fiSponsor.sponsors[0].name !== 'West Community Credit Union' && window._fiSponsor.sponsors[0].name !== 'Tigers Credit Union') ? "Non Customers are active users linked to an account at a different financial institution" : "Non Members are active users linked to an account at a different financial institution"

		var percLabel = (Object.keys(this.props.fi.data).length) ? this.props.fi.data.summary[1].y + "% of your users use\nother financial institutions" : '';
	  	var fiChart = Containers.getContainerDisplay(this.props.fi, Graphs.fi_users_pie, {key : 'summary', addParam : percLabel});
  		return (
  			<div className="BigPieChart-Outer">
  			<div className="BigPieChart-Header">{tooltipString}</div>
  			<div className="BigPieChart" style={{width: fiPieSize.width, height: fiPieSize.height}} >
  				{fiChart}
  			</div>
  			</div>
  		);
	}
}

export default BigPieChart;








